import React from 'react';
import { SortByDirection } from '@patternfly/react-table';
import { Button } from '@patternfly/react-core';
import { SortAmountDownIcon, SortAmountUpIcon } from '@patternfly/react-icons';
export function flipDirection(direction) {
    return direction === SortByDirection.asc ? SortByDirection.desc : SortByDirection.asc;
}
var SortBy = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? SortByDirection.asc : _b, _c = _a.onSortChange, onSortChange = _c === void 0 ? function () { return undefined; } : _c;
    return (React.createElement(Button, { variant: "plain", onClick: function (e) { return onSortChange(e, flipDirection(direction)); } }, direction === SortByDirection.asc ? React.createElement(SortAmountUpIcon, { size: "sm" }) : React.createElement(SortAmountDownIcon, { size: "sm" })));
};
export default SortBy;
//# sourceMappingURL=SortBy.js.map